module.exports = __webpack_public_path__ + "img/s32.0942e3df.png";